import {
  INIT_POST,
  INIT_PAGE_ALL,
  INIT_CATEGORIES,
  INIT_REL,
  FILTER,
  ORDER,
  ADD_ITEM_MENU,
  ADD_PAGE,
  ADD_TAG,
  ADD_COUNTRY,
  PARRILLA,
  PARRILLAUPDATE,

} from '../actions'

const initialState = {
  post:[],
  comments: [],
  categories: [],
  postrel:[],
  menus:[],
  user:[],
  pages:[],
  tags:[],
  country:[],
  parrilla:[],
}


function deleteDuplicateArray(arr, prop) {
     var nuevoArray = [];
     var lookup  = {};
 
     for (var i in arr) {
         lookup[arr[i][prop]] = arr[i];
     }
 
     for (i in lookup) {
         nuevoArray.push(lookup[i]);
     }
 
     return nuevoArray;
}

function reducer(state =  initialState, action = {}){

  switch (action.type){
    case INIT_POST: {
      let arraypost = state.post.concat(action.post)
      arraypost = deleteDuplicateArray(arraypost, 'id');
      return {
        ...state,
        post: arraypost
      }
    }

    case INIT_PAGE_ALL: {
      return {
        ...state,
        page: action.page
      }
    }

    case INIT_CATEGORIES: {
      return {
        ...state,
        categories: [action.categories]
      }
    }

    case INIT_REL: {
      return {
        ...state,
        postrel:  [...state.postrel, action.postrel]
      }
    }

    case FILTER: {
      return {
        ...state,
        post: {...state.post,
          filter: action.filter
        }
      }
    }

    case ORDER: {
      switch (action.order){
        case 'lastvoted': {
          let arraynew = state.post.sort((a, b) => a.voteScore + b.voteScore)
          return {
            ...state,
            post: { arraynew }
          }
        }
        case 'morevoted': {
          let arraynew = state.post.sort((a, b) => a.voteScore - b.voteScore)
          return {
            ...state,
            post: { arraynew }
          }
        }
        case 'date': {
          let arraynew = state.post.sort((a, b) => a.timestamp + b.timestamp)
          return{
            ...state,
            post: { entities: arraynew }
          }
        }
        case 'all': {
          let arraynew = state.post.sort((a, b) => a.timestamp - b.timestamp)
          return{
            ...state,
            post: { entities: arraynew }
          }
        }
        default:{
          return state
        }
      }
    }
    
    case ADD_ITEM_MENU: {
      action.itemMenu.cat = action.slug
      let item = action.itemMenu
      return {
        ...state,
        menus:[...state.menus, item]
      }
    }

    case ADD_PAGE: {
      return {
        ...state,
        pages: action.PageObj
      }
    }

    case ADD_TAG: {
      return {
        ...state,
        tags: action.TagsObj
      }
    }

    case ADD_COUNTRY: {
      return {
        ...state,
        country: action.country
      }
    }

    case PARRILLA: {
      return {
        ...state,
        parrilla: [...state.parrilla, action.parrillaObj]
      }
    }

    case PARRILLAUPDATE: {
      
      if(typeof action.parrillaObj[0]  !== 'undefined' ){
        let title = action.parrillaObj[0].title.rendered
        let datafilter = state.parrilla
        let datapro = datafilter.map((item)=>{
          if(item.name === title){
            let arra = []
            arra['imgft_field'] = action.parrillaObj[0].imgft_field
            arra['title'] = action.parrillaObj[0].title
            arra['categoryLink'] = action.parrillaObj[0].categoryLink
            item.datapost.push(arra)
          }
          return item
        })
        return {
          ...state,
          parrilla: datapro
        }
      }else{
        return {
          ...state,
          parrilla: state.parrilla
        }
      }
      
    }

    default:{
      return state
    }
  }

}

export default reducer


// WEBPACK FOOTER //
// ./src/reducers/index.js